export enum RecommendationSource {
    Banner = 'banner',
    List = 'list',
    Card = 'card',
    Conversation = 'conversation',
    Nudge = 'nudge'
}
